module.exports = __webpack_public_path__ + "img/reason2.250976e0.png";